const actions = {
  ADD_COUNTRY_BEGIN: 'ADD_COUNTRY_BEGIN',
  ADD_COUNTRY_SUCCESS: 'ADD_COUNTRY_SUCCESS',
  ADD_COUNTRY_ERR: 'ADD_COUNTRY_ERR',

  GET_COUNTRIES_BEGIN: 'GET_COUNTRIES_BEGIN',
  GET_COUNTRIES_SUCCESS: 'GET_COUNTRIES_SUCCESS',
  GET_COUNTRIES_ERR: 'GET_COUNTRIES_ERR',

  DELETE_COUNTRY_BEGIN: 'DELETE_COUNTRY_BEGIN',
  DELETE_COUNTRY_SUCCESS: 'DELETE_COUNTRY_SUCCESS',
  DELETE_COUNTRY_ERR: 'DELETE_COUNTRY_ERR',

  UPDATE_COUNTRY_BEGIN: 'UPDATE_COUNTRY_BEGIN',
  UPDATE_COUNTRY_SUCCESS: 'UPDATE_COUNTRY_SUCCESS',
  UPDATE_COUNTRY_ERR: 'UPDATE_COUNTRY_ERR',

  AddCountryBegin: () => {
    return {
      type: actions.ADD_COUNTRY_BEGIN,
    };
  },

  AddCountrySuccess: (data) => {
    return {
      type: actions.ADD_COUNTRY_SUCCESS,
      data,
    };
  },

  AddCountryErr: (err) => {
    return {
      type: actions.ADD_COUNTRY_ERR,
      err,
    };
  },

  getCountriesBegin: () => {
    return {
      type: actions.GET_COUNTRIES_BEGIN,
    };
  },

  getCountriesSuccess: (data) => {
    return {
      type: actions.GET_COUNTRIES_SUCCESS,
      data,
    };
  },

  getCountriesErr: (err) => {
    return {
      type: actions.GET_COUNTRIES_ERR,
      err,
    };
  },

  UpdateCountryBegin: () => {
    return {
      type: actions.UPDATE_COUNTRY_BEGIN,
    };
  },

  UpdateCountrySuccess: (data) => {
    return {
      type: actions.UPDATE_COUNTRY_SUCCESS,
      data,
    };
  },

  UpdateCountryErr: (err) => {
    return {
      type: actions.UPDATE_COUNTRY_ERR,
      err,
    };
  },

  DeleteCountryBegin: () => {
    return {
      type: actions.DELETE_COUNTRY_BEGIN,
    };
  },

  DeleteCountrySuccess: (data) => {
    return {
      type: actions.DELETE_COUNTRY_SUCCESS,
      data,
    };
  },

  DeleteCountryErr: (err) => {
    return {
      type: actions.DELETE_COUNTRY_ERR,
      err,
    };
  },
};

export default actions;
